var _excluded = ["classes", "className", "data", "initialExpandedItems", "initialSelectedItem", "loadingMessage", "multiple", "onItemClick", "onItemCollapsed", "onItemExpanded", "showCheckboxes", "style", "TreeListItemClasses"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import React, { useState, useMemo } from 'react';
import { arrayOf, bool, func, object, string } from 'prop-types';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import TreeListItem, { treeListItemPropTypes } from './components/TreeListItem';
var StyledUl = styled('ul')(function (_ref) {
  var typography = _ref.theme.typography;
  return {
    fontSize: typography.body1.fontSize,
    listStyle: 'none',
    margin: 0,
    padding: 0
  };
});
var calculateSelectedItem = function calculateSelectedItem(items, targetId) {
  var _loop = function _loop(i) {
    if (items[i].id === targetId) {
      return {
        v: {
          toExpand: [],
          selectedItem: items[i].id
        }
      };
    }
    if (items[i].nestedItems) {
      var _calculateSelectedIte = calculateSelectedItem(items[i].nestedItems, targetId),
        toExpand = _calculateSelectedIte.toExpand,
        selectedItem = _calculateSelectedIte.selectedItem;
      if (selectedItem) {
        return {
          v: {
            toExpand: [items[i].id].concat(_toConsumableArray(toExpand.map(function (id) {
              return "".concat(items[i].id, "_").concat(id);
            }))),
            selectedItem: "".concat(items[i].id, "_").concat(selectedItem)
          }
        };
      }
    }
  };
  for (var i = 0; i < items.length; i += 1) {
    var _ret = _loop(i);
    if (_typeof(_ret) === "object") return _ret.v;
  }
  return {
    expanded: {},
    selectedItem: ''
  };
};
var calculateExpandedItems = function calculateExpandedItems(items, itemsToExpand) {
  var calculatedItems = [];
  var _loop2 = function _loop2(i) {
    if (!items[i].nestedItems) {
      // eslint-disable-next-line no-continue
      return "continue";
    }
    if (itemsToExpand.includes(items[i].id)) {
      calculatedItems.push(items[i].id);
    }
    if (items[i].nestedItems) {
      var nestedItems = calculateExpandedItems(items[i].nestedItems, itemsToExpand);
      var mappedNestedItems = nestedItems.map(function (id) {
        return "".concat(items[i].id, "_").concat(id);
      });
      calculatedItems.push.apply(calculatedItems, _toConsumableArray(mappedNestedItems));
    }
  };
  for (var i = 0; i < items.length; i += 1) {
    var _ret2 = _loop2(i);
    if (_ret2 === "continue") continue;
  }
  return calculatedItems;
};

/**
 * ##### List with expandable items
 *
 * `SovosFixedWidthText` will automatically wrap `data.content` that is a
 * `string` and provide a tooltip on overflow. `data.content` that is a
 * `<NODE>` will not be wrapped.
 *
 * If you need truncation with a tooltip **and** a `<NODE>`, wrap your text
 * in `SovosFixedWidthText` yourself.
 */

var SovosTreeList = function SovosTreeList(_ref2) {
  var classes = _ref2.classes,
    className = _ref2.className,
    data = _ref2.data,
    initialExpandedItemsProp = _ref2.initialExpandedItems,
    initialSelectedItemProp = _ref2.initialSelectedItem,
    loadingMessage = _ref2.loadingMessage,
    multiple = _ref2.multiple,
    onItemClick = _ref2.onItemClick,
    onItemCollapsed = _ref2.onItemCollapsed,
    onItemExpanded = _ref2.onItemExpanded,
    showCheckboxes = _ref2.showCheckboxes,
    style = _ref2.style,
    TreeListItemClasses = _ref2.TreeListItemClasses,
    rest = _objectWithoutProperties(_ref2, _excluded);
  var _useMemo = useMemo(function () {
      var expanded = {};
      var selectedItem = '';
      if (initialSelectedItemProp) {
        var _calculateSelectedIte2 = calculateSelectedItem(data, initialSelectedItemProp),
          toExpand = _calculateSelectedIte2.toExpand,
          calculatedSelectedItem = _calculateSelectedIte2.selectedItem;
        if (calculatedSelectedItem) {
          selectedItem = calculatedSelectedItem;
          toExpand.forEach(function (id) {
            expanded[id] = true;
          });
        }
      }
      if (initialExpandedItemsProp) {
        var _toExpand = calculateExpandedItems(data, initialExpandedItemsProp);
        _toExpand.forEach(function (id) {
          expanded[id] = true;
        });
      }
      return {
        initialExpandedItems: expanded,
        initialSelectedItem: selectedItem
      };
    }, [data, initialSelectedItemProp, initialExpandedItemsProp]),
    initialExpandedItems = _useMemo.initialExpandedItems,
    initialSelectedItem = _useMemo.initialSelectedItem;
  var _useState = useState(initialExpandedItems),
    _useState2 = _slicedToArray(_useState, 2),
    expanded = _useState2[0],
    setExpanded = _useState2[1];
  var _useState3 = useState([initialSelectedItem]),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedItems = _useState4[0],
    setSelectedItems = _useState4[1];
  var toggleExpand = function toggleExpand(e, id, item) {
    e.stopPropagation();
    setExpanded(function (prevExpanded) {
      var newExpanded = _objectSpread({}, prevExpanded);
      if (newExpanded[id]) {
        delete newExpanded[id];
        onItemCollapsed(item);
      } else {
        newExpanded[id] = true;
        onItemExpanded(item);
      }
      return newExpanded;
    });
  };
  var handleItemClick = function handleItemClick(id, item) {
    setSelectedItems(function (prevSelected) {
      if (prevSelected.includes(id)) {
        var copySelected = _toConsumableArray(prevSelected);
        copySelected.splice(prevSelected.indexOf(id), 1);
        return copySelected;
      }
      if (multiple) {
        return [].concat(_toConsumableArray(prevSelected), [id]);
      }
      return [id];
    });
    onItemClick(item, selectedItems);
  };
  return /*#__PURE__*/React.createElement(StyledUl, _extends({
    className: clsx('sovosTreeList', classes === null || classes === void 0 ? void 0 : classes.root, className),
    style: style
  }, rest), data.map(function (ti) {
    return /*#__PURE__*/React.createElement(TreeListItem, {
      classes: TreeListItemClasses,
      expandedItems: expanded,
      hasCheckbox: showCheckboxes,
      isExpandable: !!(ti.nestedItems || ti.nestedItemCount),
      isTopLevel: true,
      item: ti,
      key: ti.id,
      loadingMessage: loadingMessage,
      onClick: onItemClick ? handleItemClick : undefined,
      onExpand: toggleExpand,
      selectedItems: selectedItems
    });
  }));
};
SovosTreeList.propTypes = {
  /**
   * Override or extend the styles applied to the component
   */
  classes: object,
  /**
   * Extend the class name applied to the root element
   */
  className: string,
  /**
   * Array of nested list items with id, content, and type. Type can be
   * undefined (default), or one of 'DIVIDER', 'HEADER', or 'DISABLED'.
   * Dividers and headers are only permitted at the top level of the list.
   */
  data: arrayOf(treeListItemPropTypes).isRequired,
  /**
   * List of items id's to expand on initial render
   */
  initialExpandedItems: arrayOf(string),
  /**
   * Item id to select on initial render
   */
  initialSelectedItem: string,
  /**
   * Message displayed when asynchronously loading child items
   */
  loadingMessage: string,
  /**
   * Select multiple tree list items
   */
  multiple: bool,
  /**
   * Callback fired when an item in the list is clicked. When this callback
   * is not included, items do not highlight on hover and cannot be selected
   *
   * `function(item: object) => void`
   */
  onItemClick: func,
  /**
   * Callback fired when an item is collapsed.
   *
   * `function(item: object) => void`
   */
  onItemCollapsed: func,
  /**
   * Callback fired when an item is expanded. Can be used to asynchronously
   * load children
   *
   * `function(item: object) => void`
   */
  onItemExpanded: func,
  /**
   * Indicate selection(s) with checkbox
   */
  showCheckboxes: bool,
  /**
   * Inline styles applied to the root element
   */
  style: object,
  /**
   * Override or extend the styles applied to items in the list
   */
  TreeListItemClasses: object
};
SovosTreeList.defaultProps = {
  classes: undefined,
  className: undefined,
  initialExpandedItems: undefined,
  initialSelectedItem: undefined,
  multiple: false,
  onItemClick: undefined,
  onItemCollapsed: function onItemCollapsed() {},
  onItemExpanded: function onItemExpanded() {},
  showCheckboxes: false,
  style: undefined,
  TreeListItemClasses: {},
  loadingMessage: undefined
};
export default SovosTreeList;